import { render, staticRenderFns } from "./login.vue?vue&type=template&id=f5173bd8&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=f5173bd8&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/page/login.less?vue&type=style&index=1&id=f5173bd8&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5173bd8",
  null
  
)

export default component.exports